import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { aboutItems } from "@/mocks/film";

export default function About() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="What You Get"
              title="本站提供什么"
              desc="围绕“剧情相关延伸”这一条主线，把散落在不同方向的关注点整理成六个清晰的板块。每个板块都提供新的信息，互不重复，你可以按顺序阅读，也可以直接跳到感兴趣的部分。"
            />
          </Reveal>

          <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {aboutItems.map((item, index) => (
              <Reveal key={item.title} delay={index * 70}>
                <button
                  type="button"
                  onClick={() => scrollTo(item.anchor)}
                  className="group w-full h-full text-left p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50/60 transition-colors cursor-pointer flex flex-col"
                >
                  <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className={`${item.icon} text-2xl`} />
                  </span>
                  <h3 className="mt-4 font-heading text-lg md:text-xl font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-foreground-600 flex-1">
                    {item.desc}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1.5 font-label text-sm text-primary-600">
                    前往查看
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                  </span>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}